// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
    padding-top: 30px;
    padding-bottom: 30px;
}

.login-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow-y: scroll;
    height: 88vh;
    padding-bottom: 150px;
}

.login-container > form {
    background-color: #0e0f15;
    border: 1px solid #f09502;
}

.login-container > form hr {
    border-top: 1px solid white;
}

.login-container .links {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
}

.login-container .links button {
    display: block;
    margin-right: 5px;
    margin-left: 5px;
}

@media (max-width: 500px) {
    .login-container > form {
        padding: 15px !important;
    }

    .login-container > form hr {
        margin: 25px 0 !important;
    }

    .login-container > form > button {
        margin-bottom: 5px !important;
    }

    .login-container .links button {
        margin-right: 0;
        margin-left: 0;
    }

    .login-container .links button:first-child {
        margin-bottom: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/login/login.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[":host {\n    width: 100%;\n    padding-top: 30px;\n    padding-bottom: 30px;\n}\n\n.login-container {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    overflow-y: scroll;\n    height: 88vh;\n    padding-bottom: 150px;\n}\n\n.login-container > form {\n    background-color: #0e0f15;\n    border: 1px solid #f09502;\n}\n\n.login-container > form hr {\n    border-top: 1px solid white;\n}\n\n.login-container .links {\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-wrap: wrap;\n}\n\n.login-container .links button {\n    display: block;\n    margin-right: 5px;\n    margin-left: 5px;\n}\n\n@media (max-width: 500px) {\n    .login-container > form {\n        padding: 15px !important;\n    }\n\n    .login-container > form hr {\n        margin: 25px 0 !important;\n    }\n\n    .login-container > form > button {\n        margin-bottom: 5px !important;\n    }\n\n    .login-container .links button {\n        margin-right: 0;\n        margin-left: 0;\n    }\n\n    .login-container .links button:first-child {\n        margin-bottom: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
